import { useMemo } from "react";

import { typedQueryClient } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";

import type { WebSocketMessageListener } from "components";
import type { CheckInServicePendingChecklist } from "models";

export const useCheckInServiceChecklistsListeners = () => {
  const listeners = useMemo(() => {
    const checkInServiceChecklistsListeners: WebSocketMessageListener<CheckInServicePendingChecklist>[] = [
      {
        model: "CheckInServicePendingChecklist",
        action: "upsert",
        callback: ({ data: checkInServicePendingChecklist }) => {
          const checkInServicePendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.servicePendingChecklists);

          const checkInServicePendingChecklistIdx =
            checkInServicePendingChecklists?.findIndex(
              p => p.checklist_id === checkInServicePendingChecklist.checklist_id && p.checkin_service_id === checkInServicePendingChecklist.checkin_service_id
            ) ?? -1;

          const updatedCheckInServiceChecklists = [...(checkInServicePendingChecklists || [])];

          if (checkInServicePendingChecklistIdx < 0) updatedCheckInServiceChecklists.push(checkInServicePendingChecklist);
          else
            updatedCheckInServiceChecklists[checkInServicePendingChecklistIdx] = {
              ...updatedCheckInServiceChecklists[checkInServicePendingChecklistIdx],
              ...checkInServicePendingChecklist
            };

          typedQueryClient.setQueryData(PendingChecklistsQueryKeys.servicePendingChecklists, updatedCheckInServiceChecklists);
        }
      },
      {
        model: "CheckInServicePendingChecklist",
        action: "delete",
        callback: ({ data: checkInServicePendingChecklist }) => {
          const checkInServicePendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.servicePendingChecklists);
          if (!checkInServicePendingChecklists || !checkInServicePendingChecklists.length) return;

          const checkInServicePendingChecklistIdx = checkInServicePendingChecklists.findIndex(
            p => p.checklist_id === checkInServicePendingChecklist.checklist_id && p.checkin_service_id === checkInServicePendingChecklist.checkin_service_id
          );
          if (checkInServicePendingChecklistIdx < 0) return;

          typedQueryClient.setQueryData(
            PendingChecklistsQueryKeys.servicePendingChecklists,
            checkInServicePendingChecklists.toSpliced(checkInServicePendingChecklistIdx, 1)
          );
        }
      }
    ];

    return [...checkInServiceChecklistsListeners];
  }, []);

  return listeners;
};
